const ITEMS = ["AI Appearance Analysis", "Personalized Recommendations", "Discover Your Style", "Smart Shopping", "Elevate Your Look"];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 py-6 bg-[#0A0A0A]" aria-hidden="true">
            <div className="flex whitespace-nowrap animate-marquee-slow w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="font-serif-display text-3xl sm:text-4xl text-outline px-8">{item}</span>
                                <span className="w-2 h-2 rotate-45 bg-amber-500/70" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
